import React, {useMemo} from 'react';
import {Input, InputBase, Loader} from "@mantine/core";
import {PersonByEmail} from "../../PersonByEmail";
import {IDynamicPerson} from "@microsoft/mgt-react";
import { useGetPrismLeadsQuery } from '@repo/services';
import {errorBoundaryWrapper} from "@repo/utils";

interface TransactionTeamExecCardProps {
    role: string | undefined;
}

/**
 * Rendered outside the parent component so its type identity is stable across
 * renders. Declaring it inline caused React to treat it as a new component type
 * on every render, unmounting/remounting the underlying PersonByEmail and
 * restarting its Graph loading state (the visible flicker).
 */
function SelectOption({ email, fullName }: { email?: string; fullName?: string }) {
    return (
        <PersonByEmail
            //@ts-ignore
            view={"oneline"}
            avatarSize='large'
            fallbackDetails={{ mail: 'Loading Team Member...', displayName: fullName } as IDynamicPerson}
            personCardInteraction={"click"}
            email={email || ""}
        />
    );
}

/**
 * Displays the executive (CEO or CFO) designated as valid for a high-value transaction team, showing their person card or a loading placeholder while lead data is fetched.
 *
 * @param role - Which executive role to display, either "ceo" or "cfo".
 */
const TransactionTeamExecCard = ({role}: TransactionTeamExecCardProps) => {
  const { data: prismLeads = [], isLoading: prismLeadsLoading } = useGetPrismLeadsQuery(null);

    const executives = useMemo(() => {
        return {
          ceo: prismLeads?.find((lead) => lead?.validForTransactionCeo),
          cfo: prismLeads?.find((lead) => lead?.validForTransactionCfo)
        }
    }, [prismLeads]);

    const selectedOption = useMemo(() => {
        if (role && executives) {
            return  executives[role as keyof typeof executives];
        }
    },[role, executives]);


    return (
        <>
            <InputBase
                style={{ maxWidth: 800 }}
                component="button"
                type="button"
                pointer
                size="lg"
                styles={(theme) => ({
                    input: {
                        // borderBottomLeftRadius: "10px",
                        // borderTopLeftRadius: "10px",
                        // borderBottomRightRadius: 0,
                        // borderTopRightRadius: 0,
                        borderRadius: "10px",
                        height: "80px"
                    },
                })}
                rightSectionPointerEvents="none"
                multiline
            >
                {/*{employeesLoading && !selectedOption && (*/}
                {/*    <Loader />*/}
                {/*)}*/}
                {selectedOption ? (
                    <SelectOption {...selectedOption} />
                ) : (
                    <Input.Placeholder><Loader /></Input.Placeholder>
                )}
            </InputBase>
        </>
    );
};

export default errorBoundaryWrapper(TransactionTeamExecCard);
